/*
 * Rastreio — consulta o pedido sem sair da loja.
 *
 * Manda pedido + e-mail para a Edge Function `rastrear-pedido` e monta a
 * resposta aqui. Quem explica o desenho inteiro, e por que o e-mail é
 * obrigatório, é `crm/supabase/functions/rastrear-pedido/index.ts`.
 *
 * DUAS REGRAS QUE NÃO SE AFROUXAM:
 *
 * 1. Todo texto vem do bloco JSON que a section imprime a partir de `locales/`.
 *    Nenhuma frase nasce neste arquivo. Se faltar chave, a tela mostra vazio em
 *    vez de inventar português.
 *
 * 2. Dado que veio do servidor entra na página por `textContent`, nunca por
 *    `innerHTML`. Título de produto e nome de transportadora são texto de
 *    terceiro, e `innerHTML` os transformaria em HTML executável.
 *
 * NÃO CONHECE TRANSPORTADORA. Não há nome de fornecedor neste arquivo. O que
 * chega, ele mostra. Remessa sem link mostra só o código, e está certo.
 */
(function () {
  var caixa = document.querySelector('[data-rastreio]');
  if (!caixa) return;

  var form = caixa.querySelector('[data-rastreio-form]');
  var alvoErro = caixa.querySelector('[data-rastreio-erro]');
  var alvoResultado = caixa.querySelector('[data-rastreio-resultado]');
  var botao = caixa.querySelector('[data-rastreio-enviar]');
  var fonteTextos = caixa.querySelector('[data-rastreio-textos]');
  var endpoint = caixa.dataset.rastreioEndpoint;
  if (!form || !alvoErro || !alvoResultado || !botao || !fonteTextos || !endpoint) return;

  var textos = {};
  try {
    textos = JSON.parse(fonteTextos.textContent) || {};
  } catch (e) {
    /* Sem os textos não há tela para montar, e um formulário que não responde é
       pior que um formulário ausente: o cliente fica clicando. Deixa o form
       parado e sai. */
    return;
  }

  var T = textos.resultado || {};
  var SITUACOES = textos.situacoes || {};
  var ERROS = textos.erros || {};

  /* Cor de estado da etiqueta. Verde, vermelho e tinta são cores de ESTADO no
     design system, e situação de entrega é exatamente isso. */
  var TOM = {
    entregue: 'etiqueta--erva',
    retirada: 'etiqueta--erva',
    falha: 'etiqueta--vermelho',
    nao_entregue: 'etiqueta--vermelho',
    cancelada: 'etiqueta--vermelho',
    tentativa_entrega: 'etiqueta--vermelho'
  };

  function elemento(tag, classe, texto) {
    var no = document.createElement(tag);
    if (classe) no.className = classe;
    if (texto !== undefined && texto !== null && texto !== '') no.textContent = texto;
    return no;
  }

  /* Data vem em ISO da Shopify. Data inválida ou ausente devolve null, e quem
     chama simplesmente não imprime a linha — melhor faltar a linha do que
     mostrar "Invalid Date" na cara do cliente.

     O `emUtc` existe por causa de um erro pego no ensaio de 09/09/2026: a
     previsão de entrega chega como `2026-09-12T00:00:00Z`, meia-noite em UTC,
     que no Brasil (UTC-3) é dia 11 às 21h. Formatada no fuso local, a data de
     entrega aparecia UM DIA ANTES do prometido.

     Por isso os dois casos são tratados diferente, e a diferença é de natureza:
     previsão de entrega é um DIA DE CALENDÁRIO e se lê em UTC, do jeito que o
     transportador escreveu. Já o despacho é um INSTANTE que de fato aconteceu, e
     se lê no fuso de quem está olhando. */
  function dataLegivel(iso, emUtc) {
    if (!iso) return null;
    var d = new Date(iso);
    if (isNaN(d.getTime())) return null;
    var opcoes = { day: 'numeric', month: 'long', year: 'numeric' };
    if (emUtc) opcoes.timeZone = 'UTC';
    return d.toLocaleDateString('pt-BR', opcoes);
  }

  function limpar(no) {
    while (no.firstChild) no.removeChild(no.firstChild);
  }

  function mostrarErro(chave) {
    limpar(alvoResultado);
    alvoResultado.hidden = true;
    alvoErro.textContent = ERROS[chave] || ERROS.indisponivel || '';
    alvoErro.hidden = false;
    alvoErro.focus();
  }

  function linhaDado(rotulo, valor) {
    if (!valor) return null;
    var fragmento = document.createDocumentFragment();
    fragmento.appendChild(elemento('dt', 'rastreio__rotulo', rotulo));
    fragmento.appendChild(elemento('dd', 'rastreio__valor', valor));
    return fragmento;
  }

  function montarRemessa(remessa) {
    var artigo = elemento('article', 'rastreio__remessa');

    var topo = elemento('div', 'rastreio__remessa-topo');
    /* Sem transportadora informada, o título cai para a palavra genérica do
       locale. Acontece em envio marcado como despachado na mão. */
    topo.appendChild(elemento('h3', 'rastreio__transportadora', remessa.transportadora || T.remessa || ''));

    var chave = remessa.situacao || 'desconhecida';
    var rotuloSituacao = SITUACOES[chave] || SITUACOES.desconhecida || '';
    if (rotuloSituacao) {
      topo.appendChild(elemento('span', 'etiqueta ' + (TOM[chave] || 'etiqueta--tinta'), rotuloSituacao));
    }
    artigo.appendChild(topo);

    var dados = elemento('dl', 'rastreio__dados');
    var linhas = [
      linhaDado(T.codigo, remessa.codigo),
      linhaDado(T.despachada_em, dataLegivel(remessa.despachada_em, false)),
      linhaDado(T.previsao, dataLegivel(remessa.previsao, true))
    ];
    var temLinha = false;
    linhas.forEach(function (linha) {
      if (linha) { dados.appendChild(linha); temLinha = true; }
    });
    if (temLinha) artigo.appendChild(dados);

    if (remessa.itens && remessa.itens.length) {
      artigo.appendChild(elemento('h4', 'rastreio__subtitulo', T.itens || ''));
      var lista = elemento('ul', 'rastreio__itens');
      lista.setAttribute('role', 'list');
      remessa.itens.forEach(function (item) {
        var nome = item.titulo || '';
        if (item.variante) nome = nome + ' (' + item.variante + ')';
        var qtd = item.quantidade > 1 ? item.quantidade + ' × ' : '';
        lista.appendChild(elemento('li', null, qtd + nome));
      });
      artigo.appendChild(lista);
    }

    if (remessa.url) {
      var link = elemento('a', 'botao botao--secundaria botao--m', T.acompanhar || '');
      link.href = remessa.url;
      link.target = '_blank';
      /* `noopener` é obrigatório: a página da transportadora é de terceiro e com
         `target="_blank"` ela ganharia referência à janela da loja. */
      link.rel = 'noopener noreferrer';
      artigo.appendChild(link);
    } else if (remessa.codigo) {
      artigo.appendChild(elemento('p', 'rastreio__sem-link', T.sem_link || ''));
    }

    return artigo;
  }

  function montarAviso(titulo, texto) {
    var aviso = elemento('div', 'rastreio__aviso');
    aviso.appendChild(elemento('h3', 'rastreio__subtitulo', titulo || ''));
    aviso.appendChild(elemento('p', null, texto || ''));
    return aviso;
  }

  function mostrarResultado(dados) {
    alvoErro.hidden = true;
    limpar(alvoResultado);

    var cabecalho = elemento('div', 'rastreio__cabecalho');
    cabecalho.appendChild(elemento('h2', 'rastreio__pedido', (T.pedido || '') + ' ' + (dados.pedido || '')));
    var feitoEm = dataLegivel(dados.feito_em);
    if (feitoEm) {
      cabecalho.appendChild(elemento('p', 'rastreio__meta', (T.feito_em || '') + ' ' + feitoEm));
    }
    alvoResultado.appendChild(cabecalho);

    if (dados.cancelado_em) {
      alvoResultado.appendChild(montarAviso(T.cancelado_titulo, T.cancelado_texto));
    } else if (!dados.remessas || !dados.remessas.length) {
      alvoResultado.appendChild(montarAviso(T.sem_remessa_titulo, T.sem_remessa_texto));
    } else {
      dados.remessas.forEach(function (remessa) {
        alvoResultado.appendChild(montarRemessa(remessa));
      });
    }

    if (textos.conta_url) {
      var conta = elemento('a', 'link-sublinhado rastreio__conta', T.conta || '');
      conta.href = textos.conta_url;
      alvoResultado.appendChild(conta);
    }

    alvoResultado.hidden = false;
    alvoResultado.focus();
  }

  function ocupado(estado) {
    botao.disabled = estado;
    botao.setAttribute('aria-busy', estado ? 'true' : 'false');
    botao.textContent = estado ? (textos.buscando || '') : (textos.enviar || '');
  }

  form.addEventListener('submit', function (evento) {
    evento.preventDefault();
    if (botao.disabled) return;

    var pedido = form.elements.pedido.value.trim();
    var email = form.elements.email.value.trim();
    /* O `required` do HTML já barra o vazio; esta guarda cobre o caso de o
       navegador não validar e evita uma ida ao servidor que já se sabe perdida. */
    if (!pedido || !email) return;

    ocupado(true);

    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ pedido: pedido, email: email })
    })
      .then(function (resposta) {
        return resposta.json().then(function (corpo) {
          return { ok: resposta.ok, corpo: corpo };
        });
      })
      .then(function (r) {
        if (r.ok) {
          mostrarResultado(r.corpo);
        } else {
          mostrarErro((r.corpo && r.corpo.erro) || 'indisponivel');
        }
      })
      .catch(function () {
        /* Cai aqui quando não houve resposta: sem rede, CORS barrado, função
           fora do ar. É diferente de "o servidor disse não", e o texto também. */
        mostrarErro('rede');
      })
      .then(function () {
        ocupado(false);
      });
  });
})();
